/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */

import { Separator } from "../components/scorecardItem/Separator";
import { MatchPlayCard } from "./MatchPlayCard";
import { WaysCard } from "./WaysCard";

function ScoreItem({ score, type, index }) {
  const gameType = {
    0: "F9",
    1: "B9",
    2: "Front 9",
    3: "Back 9",
    4: "Full 18",
  };

  const renderType = () => {
    if (index <= 3) {
      // eslint-disable-next-line no-unused-expressions
      return index > 0
        ? `${gameType[type]}: Press ${index + 1}`
        : `${gameType[type]}: Press ${index + 1}`;
    }
    return gameType[type];
  };

  return (
    typeof score === "number" && (
      <MatchPlayCard score={score} type={renderType()} />
    )
  );
}

export default function MatchPlayMatchTabScorecard({
  data,
  stake,
  teamData,
  teamsPlay,
}) {
  const matches = teamsPlay
    ? teamData.matches?.[0] ?? {
        holes: [],
        front9: {},
        back9: {},
        big18: {},
      }
    : data.matches?.[0] ?? {
        holes: [],
        front9: {},
        back9: {},
        big18: {},
      };

  const { holes, big18, back9, front9 } = matches ?? {};

  // eslint-disable-next-line prefer-destructuring, no-unsafe-optional-chaining
  const lastHoleSubmitted = holes?.length >= 1 ? holes?.length - 1 : 0;

  const dataObject = {
    playingBig18: holes[lastHoleSubmitted]?.big18?.score || 0,
    playingFront9: holes[lastHoleSubmitted]?.front9?.score || 0,
    playingBack9: holes[lastHoleSubmitted]?.back9?.score || 0,
    playingFront9Presses: holes[lastHoleSubmitted]?.front9?.presses || [],
    playingBack9Presses: holes[lastHoleSubmitted]?.back9?.presses || [],
    completedBig18: big18?.margin || 0,
    completedFront9: front9?.margin || 0,
    completedBack9: back9?.margin || 0,
    completedFront9Presses: front9?.presses || [],
    completedBack9Presses: back9?.presses || [],
    countFront9PlayingPresses:
      holes[lastHoleSubmitted]?.front9?.presses?.length || 0,
    countBack9PlayingPresses:
      holes[lastHoleSubmitted]?.back9?.presses?.length || 0,
    countFront9CompletedPresses: front9?.presses?.length || 0,
    countBack9CompletedPresses: back9?.presses?.length || 0,
    f9WinByScore: front9.winByScore,
    b9WinByScore: back9.winByScore,
    f18WinByScore: big18.winByScore,
    isCompletedMatch: lastHoleSubmitted === 17,
    isCompletedFront9: lastHoleSubmitted === 9,
    isCompletedBack9: null,
    isCompletedBig18: lastHoleSubmitted === 17 && big18.winByScore,
  };

  const isFirstHole = lastHoleSubmitted === 0;
  const isFront9 = lastHoleSubmitted < 8;
  const isNineHole = lastHoleSubmitted === 8;
  const isBack9 = lastHoleSubmitted > 8;

  const pressAMinusBFront9 =
    dataObject.countFront9PlayingPresses -
    dataObject.countFront9CompletedPresses;

  const pressAMinusBBack9 =
    dataObject.countBack9PlayingPresses - dataObject.countBack9CompletedPresses;

  const summaryPlayingCalculation =
    [
      !dataObject.f9WinByScore && dataObject.playingFront9,
      !dataObject.f18WinByScore && dataObject.playingBig18,
      !dataObject.b9WinByScore && dataObject.playingBack9,
      ...dataObject.playingFront9Presses
        .slice(dataObject.countFront9PlayingPresses - pressAMinusBFront9)
        .map((i) => i.score),
      ...dataObject.playingBack9Presses
        .slice(dataObject.countBack9PlayingPresses - pressAMinusBBack9)
        .map((i) => i.score),
    ].reduce((acc, val) => {
      if (val > 0) {
        return acc + 1;
      }
      if (val < 0) {
        return acc - 1;
      }
      return acc;
    }, 0) * stake || 0;

  const summaryCompletedCalculation =
    [
      dataObject.b9WinByScore && dataObject.completedBack9,
      dataObject.f18WinByScore && dataObject.completedBig18,
      dataObject.f9WinByScore && dataObject.completedFront9,
      ...dataObject.completedFront9Presses.map((i) => i.margin),
      ...dataObject.completedBack9Presses.map((i) => i.margin),
    ].reduce((acc, val) => {
      if (val > 0) {
        return acc + 1;
      }
      if (val < 0) {
        return acc - 1;
      }
      return acc;
    }, 0) * stake || 0;

  const waysPlayingCalculation =
    [
      !dataObject.f9WinByScore && dataObject.playingFront9,
      !dataObject.f18WinByScore && dataObject.playingBig18,
      !dataObject.b9WinByScore && dataObject.playingBack9,
      ...dataObject.playingFront9Presses
        .slice(dataObject.countFront9PlayingPresses - pressAMinusBFront9)
        .map((i) => i.score),
      ...dataObject.playingBack9Presses
        .slice(dataObject.countBack9PlayingPresses - pressAMinusBBack9)
        .map((i) => i.score),
    ].reduce((acc, val) => {
      if (val > 0) {
        return acc + 1;
      }
      if (val < 0) {
        return acc - 1;
      }
      return acc;
    }, 0) || 0;

  const waysCompletedCalculation =
    [
      dataObject.b9WinByScore && dataObject.completedBack9,
      dataObject.f18WinByScore && dataObject.completedBig18,
      dataObject.f9WinByScore && dataObject.completedFront9,
      ...dataObject.completedFront9Presses.map((i) => i.margin),
      ...dataObject.completedBack9Presses.map((i) => i.margin),
    ].reduce((acc, val) => {
      if (val > 0) {
        return acc + 1;
      }
      if (val < 0) {
        return acc - 1;
      }
      return acc;
    }, 0) || 0;

  const firstHoleRender = {
    playing: {
      F9: dataObject.playingFront9,
      F18: dataObject.playingBig18,
    },
    completed: {},
    summary: [
      {
        type: 1, // playing
        value: summaryPlayingCalculation,
      },
      {
        type: 0, // completed
        value: summaryCompletedCalculation,
      },
      {
        type: 2,
        value: summaryPlayingCalculation + summaryCompletedCalculation,
      },
    ],
    waysSummary: [
      {
        type: 1, // playing
        value: waysPlayingCalculation,
      },
      {
        type: 0, // completed
        value: waysCompletedCalculation,
      },
      {
        type: 2,
        value: waysPlayingCalculation + waysCompletedCalculation,
      },
    ],
  };

  const front9Render = {
    playing: {
      F9: !dataObject.f9WinByScore && dataObject.playingFront9,
      F18: !dataObject.f18WinByScore && dataObject.playingBig18,
      F9P: dataObject.playingFront9Presses.slice(
        dataObject.countFront9PlayingPresses - pressAMinusBFront9,
      ),
    },
    completed: {
      F9: dataObject.f9WinByScore && dataObject.completedFront9,
      F18: dataObject.f18WinByScore && dataObject.completedBig18,
      F9CP: dataObject.completedFront9Presses,
    },
    summary: [
      {
        type: 1, // playing
        value: summaryPlayingCalculation,
      },
      {
        type: 0, // completed
        value: summaryCompletedCalculation,
      },
      {
        type: 2,
        value: summaryPlayingCalculation + summaryCompletedCalculation,
      },
    ],
    waysSummary: [
      {
        type: 1, // playing
        value: waysPlayingCalculation,
      },
      {
        type: 0, // completed
        value: waysCompletedCalculation,
      },
      {
        type: 2,
        value: waysPlayingCalculation + waysCompletedCalculation,
      },
    ],
  };

  const nineHoleRender = {
    playing: {
      // F9: !dataObject.f9WinByScore && dataObject.playingFront9,
      F18: !dataObject.f18WinByScore && dataObject.playingBig18,
      B9: !dataObject.b9WinByScore && dataObject.playingBack9,
      F9P: dataObject.playingFront9Presses.slice(
        dataObject.countFront9PlayingPresses - pressAMinusBFront9,
      ),
      B9P: dataObject.playingBack9Presses.slice(
        dataObject.countBack9PlayingPresses - pressAMinusBBack9,
      ),
    },
    completed: {
      F9: dataObject.completedFront9,
      F18: dataObject.f18WinByScore && dataObject.completedBig18,
      F9CP: dataObject.completedFront9Presses,
    },
    summary: [
      {
        type: 1, // playing
        value: summaryPlayingCalculation,
      },
      {
        type: 0, // completed
        value: summaryCompletedCalculation,
      },
      {
        type: 2,
        value: summaryPlayingCalculation + summaryCompletedCalculation,
      },
    ],
    waysSummary: [
      {
        type: 1, // playing
        value: waysPlayingCalculation,
      },
      {
        type: 0, // completed
        value: waysCompletedCalculation,
      },
      {
        type: 2,
        value: waysPlayingCalculation + waysCompletedCalculation,
      },
    ],
  };

  const back9Render = {
    playing: {
      F9:
        lastHoleSubmitted === 17
          ? false
          : !dataObject.f9WinByScore && dataObject.playingFront9,
      F18:
        lastHoleSubmitted === 17
          ? false
          : !dataObject.f18WinByScore && dataObject.playingBig18,
      B9:
        lastHoleSubmitted === 17
          ? false
          : !dataObject.b9WinByScore && dataObject.playingBack9,
      F9P: dataObject.playingFront9Presses.slice(
        dataObject.countFront9PlayingPresses - pressAMinusBFront9,
      ),
      B9P: dataObject.playingBack9Presses.slice(
        dataObject.countBack9PlayingPresses - pressAMinusBBack9,
      ),
    },
    completed: {
      F9:
        lastHoleSubmitted === 17
          ? dataObject.completedFront9
          : dataObject.f9WinByScore && dataObject.completedFront9,
      F18:
        lastHoleSubmitted === 17
          ? dataObject.completedBig18
          : dataObject.f18WinByScore && dataObject.completedBig18,
      B9:
        lastHoleSubmitted === 17
          ? dataObject.completedBack9
          : dataObject.b9WinByScore && dataObject.completedBack9,
      F9CP: dataObject.completedFront9Presses,
      B9CP: dataObject.completedBack9Presses,
    },
    summary: [
      {
        type: 1, // playing
        value: summaryPlayingCalculation,
      },
      {
        type: 0, // completed
        value: summaryCompletedCalculation,
      },
      {
        type: 2,
        value: summaryPlayingCalculation + summaryCompletedCalculation,
      },
    ],
    waysSummary: [
      {
        type: 1, // playing
        value: waysPlayingCalculation,
      },
      {
        type: 0, // completed
        value: waysCompletedCalculation,
      },
      {
        type: 2,
        value: waysPlayingCalculation + waysCompletedCalculation,
      },
    ],
  };

  const renderLogic = () => {
    if (isFirstHole) {
      return (
        <RenderItem
          playingData={firstHoleRender.playing}
          completedData={firstHoleRender.completed}
          summaryData={firstHoleRender.summary}
          waysData={firstHoleRender.waysSummary}
          pressAMinusBFront9={pressAMinusBFront9}
          pressAMinusBBack9={pressAMinusBBack9}
          countFront9PlayingPresses={dataObject.countFront9PlayingPresses}
          countBack9PlayingPresses={dataObject.countBack9PlayingPresses}
        />
      );
    }
    if (isFront9) {
      return (
        <RenderItem
          playingData={front9Render.playing}
          completedData={front9Render.completed}
          summaryData={front9Render.summary}
          waysData={front9Render.waysSummary}
          pressAMinusBFront9={pressAMinusBFront9}
          pressAMinusBBack9={pressAMinusBBack9}
          countFront9PlayingPresses={dataObject.countFront9PlayingPresses}
          countBack9PlayingPresses={dataObject.countBack9PlayingPresses}
        />
      );
    }

    if (isNineHole) {
      return (
        <RenderItem
          playingData={nineHoleRender.playing}
          completedData={nineHoleRender.completed}
          summaryData={nineHoleRender.summary}
          waysData={nineHoleRender.waysSummary}
          pressAMinusBFront9={pressAMinusBFront9}
          pressAMinusBBack9={pressAMinusBBack9}
          countFront9PlayingPresses={dataObject.countFront9PlayingPresses}
          countBack9PlayingPresses={dataObject.countBack9PlayingPresses}
        />
      );
    }

    if (isBack9) {
      return (
        <RenderItem
          playingData={back9Render.playing}
          completedData={back9Render.completed}
          summaryData={back9Render.summary}
          waysData={back9Render.waysSummary}
          pressAMinusBFront9={pressAMinusBFront9}
          pressAMinusBBack9={pressAMinusBBack9}
          countFront9PlayingPresses={dataObject.countFront9PlayingPresses}
          countBack9PlayingPresses={dataObject.countBack9PlayingPresses}
        />
      );
    }
    return null;
  };

  return (
    <>
      {renderLogic()}
      {/* {process.env.REACT_APP_TEST !== "PROD" && (
        <>
          <p>lastHoleSubmitted {lastHoleSubmitted}</p>
          <pre>{JSON.stringify(dataObject, null, 2)}</pre>
        </>
      )} */}
    </>
  );
}

function RenderItem({
  playingData,
  completedData,
  // summaryData,
  waysData,
  pressAMinusBFront9,
  pressAMinusBBack9,
  countFront9PlayingPresses,
  countBack9PlayingPresses,
}) {
  const style = {
    display: "flex",
    flexDirection: "row",
    padding: 20,
    overflowX: "scroll",
    width: "100%",
    whiteSpace: "nowrap",
  };

  const playing = (
    <div style={style}>
      <ScoreItem score={playingData.F18} type={4} />
      <ScoreItem score={playingData.F9} type={2} />
      <ScoreItem score={playingData.B9} type={3} />
      {playingData?.F9P?.map((press, index) => (
        <ScoreItem
          key={index}
          type={0}
          score={press.score ?? press.margin}
          index={index + countFront9PlayingPresses - pressAMinusBFront9}
        />
      )) || null}
      {playingData?.B9P?.map((press, index) => (
        <ScoreItem
          key={index}
          type={1}
          score={press.score ?? press.margin}
          index={index + countBack9PlayingPresses - pressAMinusBBack9}
        />
      )) || null}
    </div>
  );

  const completed = (
    <div style={style}>
      <ScoreItem score={completedData.F18} type={4} />
      <ScoreItem score={completedData.F9} type={2} />
      <ScoreItem score={completedData.B9} type={3} />

      {completedData?.F9CP?.map((press, index) => (
        <ScoreItem
          key={index}
          type={0}
          score={press.score ?? press.margin}
          index={index}
        />
      )) || null}
      {completedData?.B9CP?.map((press, index) => (
        <ScoreItem
          key={index}
          type={1}
          score={press.score ?? press.margin}
          index={index}
        />
      )) || null}
    </div>
  );

  const summary = (
    <div style={{ ...style, justifyContent: "center" }}>
      {waysData?.map((i) => (
        <WaysCard key={i.type} type={i.type} value={i.value} />
      ))}
    </div>
  ) || (
    <div style={{ ...style, justifyContent: "center" }}>
      <WaysCard type={1} value={0} />
      <WaysCard type={0} value={0} />
      <WaysCard type={2} value={0} />
    </div>
  );

  return (
    <>
      <Separator showTime teeTimeString="PLAYING" />
      {playing}
      <Separator showTime teeTimeString="COMPLETED" />
      {completed}
      <Separator showTime teeTimeString="SUMMARY" />
      {summary}
    </>
  );
}
